export const LOGIN_PAGE_URL = "/login";
export const HOME_PAGE_URL = "/devices";
